import { ServerLogger } from "@cardsgame/utils"

export const logs = new ServerLogger()
